import React, { useState, Fragment, useRef, useEffect } from "react";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import "./LayoutPanel.scss";
import { LoginUserType, ResponseCode, utils } from "utils/Utils";
import { AsyncAjaxDelete, AsyncAjaxGet, AsyncAjaxPost, AsyncAjaxPut } from "components/Common/AsyncAjaxService";
import store from "app/store";
import Loader from "components/Common/Loader";
import Alert from "react-bootstrap/Alert";
import VGPopUp from "components/Controls/VGPopUp";
import AddEditlayoutPopup from "./AddEditlayoutPopup";
import LayoutPreview from "./LayoutPreview";
import LayoutSortableItems from "./LayoutSortableItems";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, rectSortingStrategy } from '@dnd-kit/sortable';
import $ from "jquery";
import useGenerateToken from "components/Hook/useGenerateToken";

const LayoutSotableContent = (props) => {

    let LayoutList = props.layoutlist;
    if (props.layoutlist.length > 0) {
        LayoutList = props.layoutlist.filter(
            (col) => col.isActive === true
        );
    }
    const VagaroAPIEnum = {
        DeactivateLayout: "layout/deactivate",
        ActivateLayout: "layout/publish",
        IsPublishLayout: "layoutpagefile/ispublishlayout",
        GetLayoutDetails: "layout/getlayoutdetails",
        DeleteLayout: "layout/delete",
        ChangeSquanceLayout: "layout/changesquancelayout"
    }
    const { BusinessID, ReactBusinessId, ReactUserID, UserType, CDNURL } = store.getState().Business;
    const [isLoading, setLoading] = useState(false);
    const [Message, setMessage] = useState("");
    const Loading = useRef(false);
    const [IsMessageOpen, setIsMessageOpen] = useState(false);
    const [items, setItems] = useState(props.layoutlist);
    const [allLayoutNames, setAllLayoutNames] = useState(props.allLayoutName);

    const currentPageSize = props.layoutPagePageSize;
    const currentPage = useRef(props.layoutPageIndex);
    const pageSize = useRef(currentPageSize);

    const IsPublishLayout = async (layoutId) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to activate layout.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                props.setLoading(true);
                await AsyncAjaxGet(
                    VagaroAPIEnum.IsPublishLayout + "?layoutId=" + layoutId,
                    access_token,
                    function onSuccess(data) {
                        try {
                            if (
                                data != null &&
                                data.data != null
                            ) {
                                props.setLoading(false);
                                if (data != null && data.data != null && data.data.data != null && data.data.data == true) {
                                    ActivatelayoutPopup(layoutId);
                                }
                                else {
                                    return ReactDom.render(
                                        <VGPopUp
                                            id={"isPublishLayout"}
                                            show={true}
                                            onHide={PopupClose}
                                            title={"Publish the Layout to Activate It"}
                                            dialogClassName="cancelauto-renew-alert"
                                            body={
                                                <div className="alertContent">
                                                    <p>To activate this layout, please publish the layout first.</p>
                                                </div>
                                            }
                                            footer={
                                                <Fragment>
                                                    <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                                                    <button className="w-button w-button-primary" onClick={() => UseLayout(layoutId, false)}>Publish Layout</button>
                                                </Fragment >
                                            }
                                            isRemoveTabModalIndex={false}
                                            isShowFooter={true}
                                            size={"md"}
                                            backdrop={true}
                                        />,
                                        document.getElementById("OpenDialog"));
                                }
                            }
                        }
                        catch (error) {
                            props.setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Is Publish Layout",
                                layoutId,
                                ""
                            );
                        }
                    },
                    function OnError() {
                        props.setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Is Publish Layout",
                            layoutId,
                            ""
                        );
                    }
                );
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }

    const ActivateLayout = async (layoutId) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to activate layout.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                props.setLoading(true);
                await AsyncAjaxPut(
                    VagaroAPIEnum.ActivateLayout + "?layoutId=" + layoutId,
                    access_token,
                    null,
                    function onSuccess(data) {
                        try {
                            if (
                                data != null &&
                                data.data != null &&
                                data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {
                                    PopupClose();
                                    props.setLoading(false);
                                    var FilterStyleData = LayoutList.filter(
                                        (col) => col.id === layoutId
                                    );
                                    if (FilterStyleData.length > 0) {
                                        FilterStyleData[0].isActive = true;
                                        FilterStyleData[0].isSoftDelete = false;
                                        LayoutList.map((d, i) => {
                                            if (d.id === layoutId) {
                                                LayoutList[i] = FilterStyleData[0];
                                            }
                                        })
                                        props.setLayoutList(LayoutList);
                                    }
                                    setIsMessageOpen(true);
                                    setMessage("Layout has been activated successfully.");

                                }
                                else {
                                    PopupClose();
                                    props.setLoading(false);
                                }
                            }
                            else {
                                PopupClose();
                                props.setLoading(false);
                            }
                        }
                        catch (error) {
                            props.setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Activate Layout",
                                layoutId,
                                ""
                            );
                        }
                    },
                    function OnError() {
                        props.setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Activate Layout",
                            layoutId,
                            ""
                        );
                    }
                );
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }
    const DeactivateLayout = async (LayoutId) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to deactivate layout.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                props.setLoading(true);
                await AsyncAjaxDelete(
                    VagaroAPIEnum.DeactivateLayout + "?layoutId=" + LayoutId,
                    access_token,
                    function onSuccess(data) {
                        try {
                            if (
                                data != null &&
                                data.data != null &&
                                data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {
                                    PopupClose();
                                    props.setLoading(false);
                                    var FilterStyleData = LayoutList.filter(
                                        (col) => col.id === LayoutId
                                    );
                                    if (FilterStyleData.length > 0) {
                                        FilterStyleData[0].isActive = true;
                                        FilterStyleData[0].isSoftDelete = true;
                                        LayoutList.map((d, i) => {
                                            if (d.id === LayoutId) {
                                                LayoutList[i] = FilterStyleData[0];
                                            }
                                        })
                                        props.setLayoutList(LayoutList);
                                    }
                                    setIsMessageOpen(true);
                                    setMessage("Layout has been deactivated successfully.");

                                }
                                else {
                                    PopupClose();
                                    props.setLoading(false);
                                }
                            }
                            else {
                                PopupClose();
                                props.setLoading(false);
                            }
                        }
                        catch (error) {
                            props.setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Delete Layout",
                                LayoutId,
                                ""
                            );
                        }
                    },
                    function OnError() {
                        props.setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Delete Layout",
                            LayoutId,
                            ""
                        );
                    }
                );
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }

    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };

    const DeactivateLayoutPopup = (LayoutId) => {
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to deactivate Layout.", "OpenDialog");
        }
        else {
            return ReactDom.render(
                <VGPopUp
                    id={"DeactivateConformationPopup"}
                    show={true}
                    onHide={PopupClose}
                    title={"Deactivate Layout"}
                    dialogClassName="cancelauto-renew-alert"
                    body={
                        <div className="alertContent">
                            <p>This layout will no longer be displayed to businesses once deactivated. Any users currently using this layout will not be affected.</p>
                        </div>
                    }
                    footer={
                        <Fragment>
                            <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                            <button className="w-button w-button-destructive-outline" onClick={() => DeactivateLayout(LayoutId)}>Deactivate Layout</button>
                        </Fragment >
                    }
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
                />,
                document.getElementById("OpenDialog"));
        }
    }

    const ActivatelayoutPopup = (LayoutId) => {
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to deactivate Layout.", "OpenDialog");
        }
        else {
            return ReactDom.render(
                <VGPopUp
                    id={"ActivateConformationPopup"}
                    show={true}
                    onHide={PopupClose}
                    title={"Activate Layout"}
                    dialogClassName="cancelauto-renew-alert"
                    body={
                        <div className="alertContent">

                            <p>This layout will be displayed to businesses once activated.</p>
                        </div>
                    }
                    footer={
                        <Fragment>
                            <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                            <button className="w-button w-button-primary" onClick={() => ActivateLayout(LayoutId)}>Activate Layout</button>
                        </Fragment >
                    }
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
                />,
                document.getElementById("OpenDialog"));
        }
    }

    const EditLayoutPopup = async (LayoutID, Duplicate) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not permission to edit layout.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                props.setLoading(true);
                await AsyncAjaxGet(
                    VagaroAPIEnum.GetLayoutDetails + "?LayoutId=" + LayoutID,
                    access_token,
                    function onSuccess(data) {
                        try {
                            if (
                                data != null &&
                                data.data != null &&
                                data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null) {
                                    props.setLoading(false);
                                    return ReactDom.render(
                                        <AddEditlayoutPopup
                                            ReactBusinessId={ReactBusinessId}
                                            ReactUserID={ReactUserID}
                                            layoutDetails={data.data.data}
                                            LayoutID={LayoutID}
                                            StyleID={props.styleId}
                                            IsMessageOpen={setIsMessageOpen}
                                            Message={setMessage}
                                            getLayoutList={props.getLayoutList}
                                            UserType={UserType}
                                            LayoutList={LayoutList}
                                            CDNURL={CDNURL}
                                            setLoading={props.setLoading}
                                            isLoading={props.isLoading}
                                            PopupClose={PopupClose}
                                            dispatch={props.dispatch}
                                            isDuplicate={Duplicate}
                                            isBuilderPage={false}
                                            currentPage={props.layoutPageIndex}
                                            pageSize={props.layoutPagePageSize}
                                            allLayoutName={allLayoutNames}
                                            allLayoutNameOperation={props.allLayoutNameOperation}
                                        />,
                                        document.getElementById("OpenDialog"))
                                }
                            }
                        }
                        catch (error) {
                            props.setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Get Specific layout Details",
                                LayoutID,
                                ""
                            );
                        }
                    },
                    function OnError() {
                        props.setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Get Specific layout Details",
                            LayoutID,
                            ""
                        );
                    }
                );
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }

    const UseLayout = (layoutID,layoutOnly) => {
        if (typeof layoutID !== 'undefined' && layoutID !== null && layoutID !== "") {
            let a = document.createElement('a');
            a.target = '_self';
            a.href = "/admin/" + props.styleId + "/" + layoutID + "/designer"+ (layoutOnly?"?menu=layout":"");
            a.click();
        }
    }

    const DuplicateLayout = async (LayoutID) => {
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to duplicate layout.", "OpenDialog");
        }
        else {
            await EditLayoutPopup(LayoutID, true);
        }
    }


    const DeleteLayoutPopup = (LayoutId) => {
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to delete layout.", "OpenDialog");
        }
        else {
            return ReactDom.render(
                <VGPopUp
                    id={"DeleteConformationPopup"}
                    show={true}
                    onHide={PopupClose}
                    title={"Delete Layout"}
                    dialogClassName="cancelauto-renew-alert"
                    body={
                        <div className="alertContent">
                            {isLoading && <Loader />}
                            <p>This layout will be permanently deleted from your website. Any users currently using this layout will not be affected.</p>
                        </div>
                    }
                    footer={
                        <Fragment>
                            <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                            <button className="w-button w-button-destructive-outline" onClick={() => DeleteLayout(LayoutId)}>Delete Layout</button>
                        </Fragment >
                    }
                    isRemoveTabModalIndex={false}
                    isShowFooter={true}
                    size={"md"}
                    backdrop={true}
                />,
                document.getElementById("OpenDialog"));
        }
    }

    const DeleteLayout = async (LayoutId) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to delete layout.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                props.setLoading(true);
                await AsyncAjaxDelete(
                    VagaroAPIEnum.DeleteLayout + "?layoutId=" + LayoutId,
                    access_token,
                    function onSuccess(data) {
                        try {
                            if (
                                data != null &&
                                data.data != null &&
                                data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null && data.data.data.status == true) {
                                    PopupClose();
                                    props.setLoading(false);
                                    props.getLayoutList(props.styleId, false, true, 1, (currentPage.current * pageSize.current));
                                    setIsMessageOpen(true);
                                    setMessage("Layout has been deleted successfully.");
                                    var newAllLayout = allLayoutNames.filter(
                                        (col) => col.layoutId !== LayoutId
                                    );
                                    setAllLayoutNames(newAllLayout);
                                    props.allLayoutNameOperation("Delete", LayoutId);

                                }
                                else {
                                    PopupClose();
                                    props.setLoading(false);
                                }
                            }
                            else {
                                PopupClose();
                                props.setLoading(false);
                            }
                        }
                        catch (error) {
                            props.setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Delete Layout",
                                LayoutId,
                                ""
                            );
                        }
                    },
                    function OnError() {
                        props.setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Delete Layout",
                            LayoutId,
                            ""
                        );
                    }
                );
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }


    const ViewLayout = async (Layoutimage, LayoutId) => {
        const access_token = await useGenerateToken(props.dispatch);
        return ReactDom.render(
            <LayoutPreview
                Layoutimage={Layoutimage}
                BusinessId={BusinessID}
                LayoutId={LayoutId}
                StyleId={props.styleId}
                AccessToken={access_token}
            />,
            document.getElementById("OpenDialog"))
    }
    useEffect(() => {
        if (IsMessageOpen) {
            window.setTimeout(() => {
                setIsMessageOpen(false);
            }, 3000)
        }
    }, [IsMessageOpen]);

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );


    useEffect(() => {
        setItems(LayoutList)
    }, [props.layoutlist, props.layoutPageIndex, props.layoutPagePageSize])

    const LayoutReorderList = async (sourceIndex, destinationIndex) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to reorder Layout list.", "OpenDialog");
        }
        else {

            if (utils.Validate(access_token)) {
                if (props.layoutlist[sourceIndex].rank != props.layoutlist[destinationIndex].rank) {
                    props.setLoading(true);
                    const Requestdata = {};
                    Requestdata.SourceLayoutRank = props.layoutlist[sourceIndex].rank;
                    Requestdata.DestinationLayoutRank = props.layoutlist[destinationIndex].rank;
                    Requestdata.LayoutId = props.layoutlist[sourceIndex].id;
                    await AsyncAjaxPost(
                        VagaroAPIEnum.ChangeSquanceLayout,
                        Requestdata,
                        access_token,
                        function onSuccess(data) {
                            try {
                                if (
                                    data != null &&
                                    data.data != null &&
                                    data.data.responseCode == ResponseCode.Success
                                ) {
                                    props.setLoading(false);
                                    props.getLayoutList(props.styleId, false, true, 1, (currentPage.current * pageSize.current));
                                }
                                else {
                                    props.setLoading(false);
                                }
                            }
                            catch (error) {
                                props.setLoading(false);
                                utils.appInsightTrack(
                                    ReactBusinessId,
                                    ReactUserID,
                                    "Change Squance Layout",
                                    null,
                                    ""
                                );
                            }
                        },
                        function OnError() {
                            props.setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Change Squance Layout",
                                null,
                                ""
                            );
                        }
                    );
                };
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }

    const cardWrapperheight = (e) => {
        var wHeight = $(window).height();
        var titleHeight
        var tabHeight
        var tagsheight
        if ($(".titleWrapper").length) {
            titleHeight = $(".titleWrapper").outerHeight(true) + 20;
        } else {
            titleHeight = 0;
        }

        var calCardWrapperHeight = wHeight - titleHeight - tabHeight - tagsheight - 55;
        $("#layoutScrollDiv").addClass('js-hasScroll').css("max-height", calCardWrapperHeight);
        handleScrollStyles();
    }

    useEffect(() => {
        handleScrollStyles()
    }, [])


    const handleScrollStyles = (e) => {
        if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0) {
            $('#layoutScrollDiv').on('scroll', function () {
                const bottom = parseInt($(this).scrollTop() + $(this).innerHeight()) >= parseInt($(this)[0].scrollHeight);
                if (bottom && Loading.current == false) {
                    Loading.current = true;
                    if ((currentPage.current * pageSize.current) < props.layouttotalitems) {
                        currentPage.current = currentPage.current + 1;
                        props.getLayoutList(props.styleId, true, false, currentPage.current, pageSize.current);
                    }
                }
            });
        }
    }

    return (
        <Fragment>
            {props.isLoading && <Loader />}
            <div className="layout-panel">
                <div className="page-title">Select Website Layout</div>
                <div className="layout-cards-wrapper">
                    <div className="titleWrapper">
                        {IsMessageOpen &&
                            <Alert isOpen={IsMessageOpen} variant="success" className="vg-alert-strip vg-passive">
                                <i className="fas fa-check-circle"></i> {Message}
                            </Alert>
                        }
                    </div>
                    <div className="styles-cards-wrapper" id="layoutScrollDiv">
                        <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                        >

                            <SortableContext
                                items={items}
                                strategy={rectSortingStrategy}

                            >
                                {items.map(d => <LayoutSortableItems
                                    key={d.id}
                                    id={d.id}
                                    layoutTitle={d.layoutTitle}
                                    layoutDescription={d.layoutDescription}
                                    layoutImage={d.layoutImage}
                                    isActive={d.isActive}
                                    isSoftDelete={d.isSoftDelete}
                                    overallCount={d.overallCount}
                                    ViewLayout={ViewLayout}
                                    EditLayoutPopup={EditLayoutPopup}
                                    DuplicateLayout={DuplicateLayout}
                                    ActivatelayoutPopup={IsPublishLayout}
                                    DeactivateLayoutPopup={DeactivateLayoutPopup}
                                    DeleteLayoutPopup={DeleteLayoutPopup}
                                    UseLayout={UseLayout}

                                />

                                )}
                            </SortableContext>

                            {/* {LayoutList.map((list) => {
                            return (
                               
                            )
                        })} */}
                        </DndContext>
                    </div>
                </div>
            </div>
        </Fragment>
    );
    function handleDragEnd(event) {
        const { active, over } = event;
        if (active.id !== over.id) {
            setItems((items) => {
                const oldIndex = items.findIndex(x => x.id === active.id);
                const newIndex = items.findIndex(x => x.id === over.id);

                LayoutReorderList(oldIndex, newIndex);
                return arrayMove(items, oldIndex, newIndex);


            });
        }

    }
}

export default LayoutSotableContent;